import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ViewFlowLink from 'flow-doctor-lib/components/common/ViewFlowLink';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionExecutionEnrollAnalysisReason = ({
  selectedEnrollment
}) => {
  const enrollingFlowId = selectedEnrollment.contextMap.SOURCE_FLOW_ID;
  if (!enrollingFlowId) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.ACTION_EXECUTION_ENROLL.withoutFlow"
    });
  }
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.ACTION_EXECUTION_ENROLL.withFlow_jsx',
      elements: {
        ViewFlowLink,
        b: 'b'
      },
      options: {
        portalId: selectedEnrollment.portalId,
        flowId: enrollingFlowId,
        shouldUseWorkflowName: true
      }
    })
  });
};
export default ActionExecutionEnrollAnalysisReason;